import React from "react"
import { ImageIcon } from "lucide-react"
import { Mockup } from "./Mockups"

// Swappable image seam: renders a real `src` when supplied, otherwise a fake-UI
// SVG mockup (`variant`), falling back to a labelled gray box. Drop a screenshot
// URL into `src` later — no layout change.
// `aspect` is any Tailwind aspect-ratio class (e.g. "aspect-video").
export function PlaceholderImage({ src, alt, label, variant, aspect = "aspect-video", className = "" }) {
  if (src) {
    return (
      <img
        src={src}
        alt={alt || label || ""}
        className={`w-full ${aspect} object-cover rounded-xl ring-1 ring-gray-200 dark:ring-gray-700 ${className}`}
      />
    )
  }

  if (variant) {
    return (
      <div className={`w-full ${aspect} rounded-xl ring-1 ring-gray-200 dark:ring-gray-700 bg-gray-50 dark:bg-gray-800 overflow-hidden ${className}`}>
        <Mockup variant={variant} aria-label={alt || label || "Product illustration"} />
      </div>
    )
  }

  return (
    <div
      role="img"
      aria-label={alt || label || "Placeholder image"}
      className={`w-full ${aspect} rounded-xl ring-1 ring-dashed ring-gray-300 dark:ring-gray-600 bg-gray-100 dark:bg-gray-800 flex flex-col items-center justify-center gap-2 text-gray-400 dark:text-gray-500 ${className}`}
    >
      <ImageIcon className="h-6 w-6" />
      {label && <span className="text-xs font-medium px-2 text-center">{label}</span>}
    </div>
  )
}
